'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        trackers = _ref.trackers,
        _ref$onSuccess = _ref.onSuccess,
        onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
        _ref$onError = _ref.onError,
        onError = _ref$onError === undefined ? function () {} : _ref$onError;

    return {
        track: function track(params, trackerIds) {
            var activeTrackerIds = trackerIds || (0, _keys2.default)(trackers);

            var trackersComplete = activeTrackerIds.map(function (trackerId) {
                var tracker = trackers[trackerId];

                return tracker.track(params).then(function (_ref2) {
                    var response = _ref2.response;

                    onSuccess(response, params, trackerId);
                    return { response: response, params: params, trackerId: trackerId };
                }).catch(function (error) {
                    onError(error, params, trackerId);
                    return { response: error, params: params, trackerId: trackerId };
                });
            });

            return _promise2.default.all(trackersComplete);
        },


        middleware: (0, _tracker2.default)({ trackers: trackers, onSuccess: onSuccess, onError: onError })
    };
};

var _tracker = require('./redux/middlewares/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=create-trackers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/create-trackers.js
 ** module id = 560
 ** module chunks = 1
 **/